import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    deleteConfirmationSingular: (name: string) => string | React.ReactNode;
    deleteConfirmationPlural: (count: number) => string | React.ReactNode;
    deleteConfirmationButton: string;
    deleteTitle: ({ count }: {
        count: number;
    }) => string | React.ReactNode;
    successToast: ({ count, name }: {
        count: number;
        name: string;
    }) => string | React.ReactNode;
    errorToast: string;
};
export type Deps = {
    Text: any;
};
export default {
    DEFINE(_messages: Text, { Text }: Deps): void {
        return Object.defineProperties(this, {
            /** A message to display within the delete confirmation dialog when deleting one share */
            deleteConfirmationSingular: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => __intl__.intl().formatMessage({ id: "useDeleteShare.deleteConfirmationSingular?c=26rytovojiiuo", defaultMessage: "<Text>Are you sure you want to delete \" <Text1>{name}</Text1> \"? This action cannot be undone.</Text>" }, { Text: (__children__: React.ReactNode) => <Text color="tertiary">{React.Children.toArray(__children__)}</Text>, Text1: (__children__: React.ReactNode) => <Text color="primary" display="inline">{React.Children.toArray(__children__)}</Text>, name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** A message to display within the delete confirmation dialog when deleting multiple shares */
            deleteConfirmationPlural: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "useDeleteShare.deleteConfirmationPlural?c=105oj005r87mm", defaultMessage: "Are you sure you want to delete all {count} shares? This action cannot be undone." }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** A label to display for the delete confirmation button */
            deleteConfirmationButton: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDeleteShare.deleteConfirmationButton?c=7nzkz7owpk0x", defaultMessage: "Delete" }));
                },
                enumerable: true,
                configurable: true
            },
            /** A title to display for the delete confirmation dialog */
            deleteTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count }: {
                        count: number;
                    }) => __intl__.intl().formatMessage({ id: "useDeleteShare.deleteTitle?c=38vja9ngw563e", defaultMessage: "{count, plural, one {Delete Share} other {Delete {count} Shares}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** A message to display within a toast when the share is deleted */
            successToast: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count, name }: {
                        count: number;
                        name: string;
                    }) => __intl__.intl().formatMessage({ id: "useDeleteShare.successToast?c=18bi4ermoyzgr", defaultMessage: "{count, plural, one {{name} has been deleted} other {{count} shares have been deleted}}" }, { count: count, name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** A message to display within a toast when an error occurs during the attempted deletion of a share */
            errorToast: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDeleteShare.errorToast?c=72d5j5tulsyv", defaultMessage: "Something went wrong when deleting Share" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
